// jose uses modern webcrypto in the browser and thus need a secure context
// See https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts
export const isCorrectUrlForWebCrypto = () => window.isSecureContext;
